export const STAMPS_SMS_PROMPT = 'STAMPS_SMS_PROMPT';
export const STAMPS_SMS_REQUEST_CODE = 'STAMPS_SMS_REQUEST_CODE';
export const STAMPS_SMS_RESEND_CODE = 'STAMPS_SMS_RESEND_CODE';
export const STAMPS_SMS_VERIFY_CODE_WRONG_CODE = 'STAMPS_SMS_VERIFY_CODE_WRONG_CODE';
export const STAMPS_SMS_VERIFY_CODE_SUCCESS = 'STAMPS_SMS_VERIFY_CODE_SUCCESS';
export const STAMPS_SMS_VERIFY_CODE_FAILURE_CONTACT_STAMPS = 'STAMPS_SMS_VERIFY_CODE_FAILURE_CONTACT_STAMPS';
